import { render } from "./Packages.vue?vue&type=template&id=fa4df69a&scoped=true"
import script from "./Packages.vue?vue&type=script&lang=js"
export * from "./Packages.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-fa4df69a"

export default script